module.exports = __webpack_public_path__ + "img/ic_survey_enabled.6489661a.svg";